import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as CodeCompletionEditor from '@mode/notebooks/contract';
import { CellEditorStateFacade } from '@mode/notebooks/contract';
import {
  getCodeAroundCursor,
  getCurrentCodeLine,
  getCurrentCodeLineAsArray,
  getCurrentCursorPosition,
  getLinePrefixBeforeCursor,
  getLineSuffixAfterCursor,
  getTokensAroundCursor,
} from '../shared-util-ace-editor';

@Injectable()
export class CellAceEditorStateService extends CellEditorStateFacade {
  private _currentCellToken$ = new BehaviorSubject<string>('');
  private cellEditorAceMap = new Map<string, AceAjax.Editor>();

  public getCurrentCellToken(): string {
    return this._currentCellToken$.value;
  }

  public setCurrentCellToken(cellToken: string) {
    this._currentCellToken$.next(cellToken);
  }

  public registerCellEditor(editor: AceAjax.Editor, cellToken: string) {
    this.cellEditorAceMap.set(cellToken, editor);
  }

  private getCurrentCellEditor(cellToken: string): AceAjax.Editor {
    return this.cellEditorAceMap.get(cellToken) as AceAjax.Editor;
  }

  public isCellSelected(cellToken: string) {
    return (
      this._currentCellToken$.value !== '' &&
      this._currentCellToken$.value !== null &&
      this._currentCellToken$.value === cellToken
    );
  }

  public getCellEditorContext(): CodeCompletionEditor.EditorContext {
    const currentCellToken = this.getCurrentCellToken();
    const editor = this.getCurrentCellEditor(currentCellToken);

    const codeLine = getCurrentCodeLine(editor);
    const codeLineAsArray = getCurrentCodeLineAsArray(editor);
    const cursorPosition = getCurrentCursorPosition(editor);
    const linePrefix = getLinePrefixBeforeCursor(editor);
    const lineSuffix = getLineSuffixAfterCursor(editor);
    const { textFromStartToCurrent, textFromCurrentToEnd } = getCodeAroundCursor(editor);
    const { tokenAtCursor, tokenBeforeCursor, tokenAfterCursor } = getTokensAroundCursor(editor);

    return {
      codeLine,
      codeLineAsArray,
      cursorPosition,
      linePrefix,
      lineSuffix,
      textFromStartToCurrent,
      textFromCurrentToEnd,
      tokenAtCursor,
      tokenBeforeCursor,
      tokenAfterCursor,
    };
  }
}
